/**
 * PURPOSE: Cliente de administración de cuentas de delegado (FTR-0013 + FTR-0017 Phase 4).
 * RESPONSIBILITIES: Llamar /api/hayllis/v2/admin/portal-accounts/* con httpService (sesión staff y
 *   cabecera X-Hayllis-Company del interceptor de FTR-0012) y devolver el contrato desenvuelto. La
 *   contraseña solo viaja en el cuerpo del alta y del restablecimiento; nunca se guarda ni se registra.
 *   Las dos acciones SISDEU-only (reset a política, re-vínculo) solo aplican a cuentas `SISDEU_DELEGATE`;
 *   el backend las rechaza para cuentas locales.
 * COLLABORATORS: httpService.js, InstitutionAccessModal.jsx, sisdeuAdminService.js (vínculos/política/alertas).
 * ROUTE: winscore/src/services/portalAccountService.js
 */
import httpService from "./httpService.js";

export const PORTAL_ACCOUNTS_BASE = "/api/hayllis/v2/admin/portal-accounts";

const unwrap = (response) => response?.data?.data ?? {};
const accountPath = (idaccount, action = "") =>
  `${PORTAL_ACCOUNTS_BASE}/${encodeURIComponent(String(idaccount))}${action ? `/${action}` : ""}`;

export const listPortalAccounts = async (idinstitution) => {
  const response = await httpService.get(PORTAL_ACCOUNTS_BASE, { params: { idinstitution } });
  const { accounts } = unwrap(response);
  return Array.isArray(accounts) ? accounts : [];
};

export const createPortalAccount = async (payload) =>
  unwrap(await httpService.post(PORTAL_ACCOUNTS_BASE, payload)).account;

export const updatePortalAccount = async (idaccount, payload) =>
  unwrap(await httpService.patch(accountPath(idaccount), payload)).account;

export const resetPortalAccountPassword = async (idaccount, password) =>
  unwrap(await httpService.post(accountPath(idaccount, "reset-password"), { password })).account;

export const deactivatePortalAccount = async (idaccount, reason = "") => {
  const trimmed = String(reason || "").trim();
  return unwrap(await httpService.post(accountPath(idaccount, "deactivate"), trimmed ? { reason: trimmed } : {}))
    .account;
};

export const reactivatePortalAccount = async (idaccount) =>
  unwrap(await httpService.post(accountPath(idaccount, "reactivate"), {})).account;

export const revokePortalAccountSessions = async (idaccount) =>
  unwrap(await httpService.post(accountPath(idaccount, "revoke-sessions"), {})).account;

// FTR-0017 Phase 2/4: solo cuentas SISDEU_DELEGATE; el backend responde 409 ACCOUNT_NOT_SISDEU si no.
export const resetPortalAccountCapabilitiesToPolicy = async (idaccount) =>
  unwrap(await httpService.post(accountPath(idaccount, "capabilities/reset-to-policy"), {})).account;

// La identidad debe estar BLOCKED (cambio de institución en SISDEU); revincula a `idinstitution`, cuyo
// vínculo SISDEU debe estar aprobado. Capacidades siempre desde la política vigente, nunca copiadas.
export const relinkPortalAccountIdentity = async (idaccount, idinstitution) =>
  unwrap(await httpService.post(accountPath(idaccount, "identity/relink"), { idinstitution })).account;
